// Capture the HTML defaults once, then restore them when leaving a route
// with dedicated metadata. This keeps one campaign's copy off other pages.
export function createRouteMetadataUpdater(doc: Document = document) {
  const defaultTitle = doc.title
  const defaultDescription = doc.head
    .querySelector('meta[name="description"]')
    ?.getAttribute('content')

  return (meta: { title?: unknown; description?: unknown }) => {
    doc.title = typeof meta.title === 'string' && meta.title.trim() ? meta.title : defaultTitle
    const description =
      typeof meta.description === 'string' && meta.description.trim()
        ? meta.description
        : defaultDescription
    const existing = doc.head.querySelector('meta[name="description"]')
    if (description == null) {
      existing?.remove()
      return
    }
    const element = existing ?? doc.createElement('meta')
    element.setAttribute('name', 'description')
    element.setAttribute('content', description)
    if (!existing) doc.head.appendChild(element)
  }
}
